import { render, staticRenderFns } from "./SwiftBoostergreen.vue?vue&type=template&id=3d4c7272&"
import script from "./SwiftBoostergreen.vue?vue&type=script&lang=ts&"
export * from "./SwiftBoostergreen.vue?vue&type=script&lang=ts&"
import style0 from "./SwiftBoostergreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports